import {gql} from '@apollo/client'

export const DELETE_COMPETENCY_BY_USER = gql`
  mutation ($id: uuid!) {
    delete_learning_diary_competencies(where: {id: {_eq: $id}}) {
      affected_rows
    }
  }
`
